// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mcp-admin-merchant-details-section[data-v-fc8a50fc]{border-bottom:1px solid #d1d1d1}.contact-group[data-v-fc8a50fc]{margin-bottom:18px}.contact[data-v-fc8a50fc]{margin-bottom:10px}.ctype-label[data-v-fc8a50fc]{margin-top:20px;margin-bottom:10px}.contact-field[data-v-fc8a50fc]{display:-webkit-box;display:-ms-flexbox;display:flex}.label[data-v-fc8a50fc]{width:145px;font-weight:500;text-transform:uppercase;font-size:11px}.root.is-loading[data-v-fc8a50fc]{min-height:200px}", ""]);
// Exports
module.exports = exports;
